import {GridColumns, GridValueGetterParams} from '@mui/x-data-grid';
import {FormattedMessage} from 'react-intl';
import {TableIdCell} from 'src/components/common/TableIdCell';
import {LightningIcon} from 'src/components/icons/LightningIcon';
import {UserIcon} from 'src/components/icons/UserIcon';
import {LocationSortFieldEnum} from 'src/enums/locations';
import {AppRouteEnum, AppRouteSpace, formatPrice} from 'src/utils/helper';
import {DeleteLocation} from '../DeleteLocation';

const deleteCol = (canDeleteLocation: boolean, isCompanyUser = false): GridColumns => {
    return canDeleteLocation
        ? [
            {
                field: 'delete',
                width: 40,
                headerName: '',
                sortable: false,
                cellClassName: 'ampTableCell',
                align: 'right' as const,
                headerAlign: 'right' as const,
                renderCell: (params) => (
                    <DeleteLocation
                        row={params.row}
                        isCompanyUser={isCompanyUser}
                    />
                ),
            },
        ]
        : [];
};

export const columnConfigLocations = (
    canDeleteLocation = true,
    isCompanyUser = false,
    isEmployeeUser = false,
    isDriverUser = false
): GridColumns => {
    const isRestrictedUser = isCompanyUser || isEmployeeUser || isDriverUser;

    return [
        {
            field: LocationSortFieldEnum.ID,
            renderHeader: (_params) => <FormattedMessage id={'idColumnHeader'}/>,
            flex: 1.5,
            minWidth: 60,
            cellClassName: 'ampTableCell',
            valueGetter: (params) => params.row.id,
        },
        {
            field: LocationSortFieldEnum.NAME,
            renderHeader: (_params) => <FormattedMessage id={'nameOfLocationColumnHeader'}/>,
            flex: 9,
            minWidth: 160,
            cellClassName: 'ampTableCell',
            renderCell: (params) => {
                return (
                    <TableIdCell
                        label={params.row.name}
                        link={AppRouteSpace([AppRouteEnum.app, AppRouteEnum.locations, params.row.id])}
                        businessId={params.row.business.id}
                    />
                );
            },
        },
        ...(!isRestrictedUser ? [{
            field: LocationSortFieldEnum.LOCATION_TYPE,
            renderHeader: (_params: any) => <span style={{textTransform: 'uppercase'}}><FormattedMessage
                id={'locationType'}/></span>,
            flex: 3,
            minWidth: 120,
            cellClassName: 'ampTableCell',
            renderCell: (params: any) => {
                return params.row.locationType ? <FormattedMessage id={params.row.locationType}/> : '';
            },
        }] : []),
        {
            field: LocationSortFieldEnum.COUNTRY,
            renderHeader: (_params) => <FormattedMessage id={'countryColumnHeader'}/>,
            flex: 3,
            minWidth: 100,
            cellClassName: 'ampTableCell',
            valueGetter: (params) => params.row.address.country,
        },
        {
            field: LocationSortFieldEnum.CITY,
            renderHeader: (_params) => <FormattedMessage id={'cityColumnHeader'}/>,
            flex: 2,
            minWidth: 100,
            cellClassName: 'ampTableCell',
            valueGetter: (params) => params.row.address.city,
        },
        {
            field: LocationSortFieldEnum.STREET,
            renderHeader: (_params) => <FormattedMessage id={'addressColumnHeader'}/>,
            flex: 6,
            minWidth: 180,
            cellClassName: 'ampTableCell',
            valueGetter: (params) => `${params.row.address.street} ${params.row.address.houseNumber}`,
        },
        ...(!isRestrictedUser ? [{
            field: LocationSortFieldEnum.USERS_SIZE,
            renderHeader: (_params: any) => <FormattedMessage id={'clientsColumnHeader'}/>,
            flex: 2,
            minWidth: 80,
            cellClassName: 'ampTableCell',
            renderCell: (params: GridValueGetterParams) => {
                return (
                    <>
                        <UserIcon/>
                        {params.row.clientsCount}
                    </>
                );
            },
        }] : []),
        ...(!isRestrictedUser ? [{
            field: LocationSortFieldEnum.CHARGER_SIZE,
            renderHeader: (_params: any) => <FormattedMessage id={'chargersColumnHeader'}/>,
            flex: 2,
            minWidth: 100,
            cellClassName: 'ampTableCell',
            renderCell: (params: any) => {
                return (
                    <>
                        <LightningIcon/>
                        {params.row.chargePointsCount}
                    </>
                );
            },
        }] : []),
        {
            field: 'price',
            renderHeader: (_params) => <FormattedMessage id={'price'}/>,
            flex: 1,
            minWidth: 120,
            cellClassName: 'ampTableCell',
            sortable: false,
            renderCell: (params) => {
                return params.row.price
                    ? `${formatPrice(params.row.price.defaultPrice)} ${params.row.price.currency}`
                    : '-';
            },
        },
        ...deleteCol(canDeleteLocation, isCompanyUser),
    ];
};
